module.exports = __webpack_public_path__ + "static/kakao-left-5dc31ea7184222f65beb6aecc3da0821.png";